import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Tabs as AntTabs } from "antd";
import classNames from "classnames";
import "./Tabs.scss";
import { styleClasses } from "../../helpers";
const CSS_PREFIX = `lav-components-tabs`;
export const Tabs = (_a) => {
    var { className = "", size = "medium", variant = "underlined" } = _a, antTabsProps = __rest(_a, ["className", "size", "variant"]);
    return (_jsx(AntTabs, Object.assign({ className: classNames(styleClasses(CSS_PREFIX, {
            size,
            variant,
        }), { [className]: !!className }) }, antTabsProps, { size: size === "small" ? "small" : "middle", type: variant === "filled" ? "card" : "line" })));
};
